import { APPEARANCE_TYPES } from '@pdqdev/pdq-shared/dist/utils/extensions-timer-utils';

export const BANNER_VARIANT_OPTIONS: Array<{ label: string; value: string }> = [
  { label: 'Info', value: APPEARANCE_TYPES.INFO },
  { label: 'Success', value: APPEARANCE_TYPES.SUCCESS },
  { label: 'Warning', value: APPEARANCE_TYPES.WARNING },
  { label: 'Critical', value: APPEARANCE_TYPES.CRITICAL },
];
